/**
 * PRE GMU — Oficina Virtual (front público).
 * https://oficinavirtual.demo-gmu.aeioros.com/ — API OV en el mismo host (contexto /).
 */
export const environment = {
  production: false,
  environment: 'gmu',
  API_URL: 'https://oficinavirtual.demo-gmu.aeioros.com/oficinavirtualgmu',
  STATIC_BASE_PATH: '',

  optionalModules: [],

  TITLE_HEAD: 'Oficina Virtual - GMU',
  ICON_TITLE_HEAD: 'assets/emvs/favicon.ico',
  TITLE_REGISTER: 'Bienvenido a la Oficina Virtual de GMU Cordoba',
  TEXT_REGISTER: 'Gestione sus trámites fácilmente desde cualquier lugar y en cualquier momento.',
  ICON_LATERAL: 'content/images/emvs/logo-panel.png',
  LOGO_HEAD: 'content/images/emvs/logo-head.png',
  TIENE_CALENDARIO: true,
  TIENE_INFO: true,
  TIENE_BUSQUEDA: true,
  FOOTER_INFO_TITLE: null,
  FOOTER_INFO: null,
  COPYRIGHT: null,
};
